
import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { ListViewModel } from '@/definitions/view-models';
import { aclModule } from '@/store/acl';
import { PagePath, PagePaths, PageState } from '@/store/application/page.definitions';
import { pageModule } from '@/store/application/page.module';
import { multisidebarModule } from '@/store/multisidebar';
import NButton from '@/uikit/buttons/NButton.vue';
import NButtonGroup from '@/uikit/buttons/NButtonGroup.vue';
import NForm from '@/uikit/forms/NForm.vue';
import NInput from '@/uikit/input/NInput.vue';
import NLoadingCircle from '@/uikit/loading/NLoadingCircle.vue';
import NTable from '@/uikit/table/NTable.vue';
import { ITableCellChangePayload } from '@/uikit/table/NTableCell.vue';
import BlocklistItem from '@/components/common/BlocklistItem.vue';
import FilterSection from '@/components/common/filter/FilterSection.vue';
import InfiniteScroll from '@/components/common/InfiniteScroll.vue';
import SettingsMenu from '@/components/common/settings/SettingsMenu.vue';
import SettingsBar from '@/components/common/SettingsBar.vue';
import EditBlocklistForm from '@/pages/blocklist/forms/EditBlocklistForm.vue';
import { getFilterByType } from '@/pages/blocklist/forms/small-filter';
import ListPage from '@/pages/ListPage.vue';
import SessionsAndBlocklistTabs from '@/pages/sessions/tabs/SessionsAndBlocklistTabs.vue';
import { AclModelNames } from '@/pages/sessions/tabs/tabs-helper';
import SettingsPageLayout from '@/pages/settings/SettingsPageLayout.vue';
import { columns } from './blocklist-table-schema';

@Options({
  components: {
    EditBlocklistForm,
    FilterSection,
    InfiniteScroll,
    ListPage,
    NButton,
    NButtonGroup,
    NForm,
    NInput,
    NLoadingCircle,
    NTable,
    SessionsAndBlocklistTabs,
    SettingsBar,
    SettingsMenu,
    SettingsPageLayout
  }
})
export default class BlocklistPage extends Vue {
  sortField = '';
  showModalWindow = false;
  selectedItemIds: number[] = [];
  currentItem: BlocklistItem | null = null;

  get module(): ListViewModel<any, any> {
    pageModule.getPageModule(this.state).aclModelName = AclModelNames.blocklist_records;
    return pageModule.getPageModule(this.state) as unknown as ListViewModel<any, any>;
  }

  get items() {
    return this.module.items;
  }

  get columns() {
    return columns;
  }

  get selectedItems() {
    return this.module.items.filter((v) => this.selectedItemIds.includes(v.id));
  }

  get state(): PageState {
    const tab = 'blacklist';
    return pageModule.getPageStateByTab(PagePaths.BlockList, tab);
  }

  get getSmallFilterLayout() {
    const { pageType } = this.state;
    return getFilterByType(pageType);
  }

  get deleteAvailable() {
    return aclModule.getAccess('ffsecurity.delete_deviceblacklistrecord');
  }

  get modelAcl() {
    return aclModule.getModelAcl(this.module);
  }

  get sidebarModule() {
    return multisidebarModule;
  }

  activated() {
    this.sidebarModule.contentOverlap = true;
  }

  mounted() {
    this.sidebarModule.contentOverlap = true;
  }

  deactivated() {
    this.sidebarModule.contentOverlap = false;
  }

  beforeUnmount() {
    this.sidebarModule.contentOverlap = false;
  }

  scrollBottomHandler(v: number | null) {
    if (typeof v === 'number' && v < 200) {
      if (!this.module.loading && !this.module.appending) this.module.append();
    }
  }

  closeHandler() {
    this.showModalWindow = false;
  }

  handleTableSort(columnName: string) {
    this.sortField = this.sortField === columnName ? `-${columnName}` : columnName;
    this.module.filter.current.ordering = this.sortField;
    this.module.get();
  }

  async saveHandler() {
    await this.module.saveItem(this.currentItem);
    await this.module.get({ resetState: false });
    this.showModalWindow = false;
  }

  async handleTableAction(payload: ITableCellChangePayload) {
    if (payload.type === 'change') {
      this.currentItem = payload.row;
      this.showModalWindow = true;
    }
  }

  async deleteAll() {
    const promises = this.selectedItemIds.map((id: number) => this.module.delete(id));
    await Promise.all(promises);
    this.selectedItemIds = [];
    await this.module.get();
  }

  @Watch('module.filter.current', { deep: true })
  currentFilterHandler() {
    this.module.get();
  }

  @Watch('$route.path')
  changeRoutePath(v: PagePath) {
    if (v === PagePaths.BlockList) {
      this.module.get();
    }
  }
}
